import _ from 'lodash';
import { i18n } from './i18n';
import pluralize from 'pluralize';
import { TAG_TYPE } from '@/constants';
import { modelData, displayText } from '@/custom_models_extend';

export const linkTo = (h, object) => {
  let name = `${pluralize(_.map(object.cn.split('::'), str => _.snakeCase(str)).join('/'))}.show`

  return <bean-link keepNode to={{ name: name, params: { id: object.id } }}>{displayText(object)}</bean-link>
}

const components = {
  id: function() {
    return {
      width: 80
    }
  },
  type: function({ v }) {
    return {
      renderCell: (h, { props: { value } }) => {
        return <span>{i18n.t(`${modelData[v.model_name]['element']}.types.${value}`)}</span>;
      },
    }
  },
  attached: function({ v }) {
    const width = _.get(v, 'extra.type') === 'audio' ? 200 : 120

    return {
      width: width,
      renderCell: 'storageAttachment',
    }
  },
  belongsTo: function() {
    return {
      minWidth: 100,
      renderCell: (h, { props: { value } }) => {
        if (value) {
          return linkTo(h, value)
        } else {
          return <span>/</span>
        }
      },
    }
  },
  hasMany: function() {
    return {
      renderCell: (h, { props: { value } }) => {
        if (value.length) {
          return _.map(value, (object) => {
            return <div>{linkTo(h, object)}</div>
          })
        } else {
          return <span>/</span>
        }
      }
    }
  },
  enum: function({ k, v }) {
    return {
      minWidth: 100,
      renderCell: (h, { props: { scope: { row } } }) => {
        if (!row[k]) {
          return <span>/</span>
        }
        return <el-tag type={TAG_TYPE[row[k]]}>{i18n.t(`${modelData[v.model_name]['element']}.${pluralize(_.camelCase(k))}.${row[k]}`)}</el-tag>;
      },
    }
  },
  string: function() {
    return {
      minWidth: 100
    }
  },
  integer: function () {
    return {}
  },
  decimal: function () {
    return {}
  },
  float: function () {
    return {}
  },
  text: function () {
    return {
      renderCell: (h, { props: { value } }) => {
        if (!value) {
          return '<span>/</span>'
        }
        return <span style="white-space: pre-wrap; word-break: break-all">{value}</span>
      },
    }
  },
  boolean: function () {
    return {
      renderCell: 'bool'
    }
  },
  date: function () {
    return {
      renderCell: 'date'
    }
  },
  time: function () {
    return {
      renderCell: 'time'
    }
  },
  datetime: function () {
    return {
      minWidth: 120,
      renderCell: 'time',
    }
  },
  tag: function() {
    return {
      minWidth: 150,
      renderCell: (h, { props: { value } }) => {
        if (value.length) {
          return _.map(value, (object) => <el-tag style={{ 'margin-right': '3px' }}>{object}</el-tag>)
        } else {
          return <span>/</span>
        }
      },
    }
  }
}

export default function(columns) {
  let hash = {}

  _.forEach(columns, (v, k) => {
    if (v.column_type && components[_.camelCase(v.column_type)]) {
      hash[k] = _.merge({
        prop: v.prop || k,
        label: i18n.t(`${modelData[v.model_name]['element']}.${_.camelCase(k)}`),
      }, components[_.camelCase(v.column_type)]({ k, v }))
    } else {
      components.string()
    }
  })

  return hash
}
